var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    id: "Retail",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 42h-.82l1.806-10.836A1.002 1.002 0 0 0 61 30h-2.684l1.597-3.594-1.827-.812L56.128 30h-6.256l-1.958-4.406-1.827.812L47.684 30H45a.998.998 0 0 0-.986 1.165L45.82 42H44v-3a1 1 0 0 0-1-1h-2v-9c0-2.483-1.824-4.533-4.2-4.919A6.975 6.975 0 0 0 39 19c0-3.859-3.14-7-7-7s-7 3.141-7 7c0 2.001.849 3.804 2.2 5.081-2.376.386-4.2 2.436-4.2 4.919v5h-6a1 1 0 0 0-1 1v3h-4v-7h7a1 1 0 0 0 1-1V18a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h7v7H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h1v3a1 1 0 0 0 1 1h54a1 1 0 0 0 1-1v-3h1a1 1 0 0 0 1-1V43a1 1 0 0 0-1-1zM4 19h14v10H4V19zm42.181 13h2.392l1.514 3.406 1.827-.812L50.761 32h4.478l-1.153 2.594 1.827.812L57.427 32h2.392l-1.667 10H47.847l-1.666-10zM27 19c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm-9 17h6a1 1 0 0 0 1-1v-6c0-1.654 1.346-3 3-3h8c1.654 0 3 1.346 3 3v9h-2v-8a1 1 0 1 0-2 0v8h-6v-8a1 1 0 1 0-2 0v8h-9v-2zm40 24H6v-2h52v2zm2-4H4V40h38v3a1 1 0 0 0 1 1h17v12z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21h5v2H6zM14 21h2v2h-2zM6 25h5v2H6zM14 25h2v2h-2zM61 2H45a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 16H46V4h14v14z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6h10v2H48zM48 10h10v2H48zM48 14h10v2H48z",
    fill: "#21929b",
    className: "color000000 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.f038cba6c271de6d2149eaa862c97c90.svg";
export { ForwardRef as ReactComponent };